type ErrorCode =
  | 'GAMING_SQUAD_NOT_FOUND'
  | 'INVALID_OPERATION'
  | 'INVALID_PARAM'
  | 'PENDING_REQUEST'
  | 'SAME_CONTEXT'
  | 'TOURNAMENT_NOT_FOUND'
  | 'UNAUTHORIZED'
  | 'USER_INPUT';

type GCInstantError = Error & { code: ErrorCode; isRetryable?: boolean };

export function createError(
  code: ErrorCode,
  message?: string,
  opts?: { isRetryable?: boolean },
): GCInstantError {
  const error = new Error(message || code) as GCInstantError;
  error.code = code;
  error.isRetryable = opts?.isRetryable;
  return error;
}

export function hasNestedError(
  error: Error | { error: Error },
): error is { error: Error } {
  return error && typeof error === 'object' && 'error' in error;
}

export function unwrapNestedError(error: Error | { error: Error }): Error {
  return hasNestedError(error) ? error.error : error;
}
